import type { TypedMyBrandOrigin } from './-MyBrandOrigin';
import RawMyBrandOrigin from './MyBrandOrigin.vue';
export * from './-MyBrandOrigin';
export const MyBrandOrigin = RawMyBrandOrigin as typeof TypedMyBrandOrigin;
